// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"c-","footer":"c_","subscriptionsList":"da","disclaimer":"db"};